
import { useEffect, useState, useCallback, useRef } from "react";
import { createPortal } from "react-dom";
import { consultarSimple } from "../../../functions/crud";
import "../../css/tickets.css";


export const CORREO_SOPORTE = "sistemas@coordinarseguridad.com";

export const RUTA_CATEGORIAS = "tickets/categoria";
export const RUTA_USUARIOS = "tickets/usuarios";
export const RUTA_LISTADO = "tickets/listado";

// Correo "TICKET DE ATENCIÓN TÉCNICA" al solicitante, con copia a desarrollo.
// Mismos campos que la app (backend.dart → /tickets/enviarcorreo). Si falla no
// se interrumpe la creación del ticket: el ticket ya quedó guardado.
export const enviarCorreoTicket = async (ticket) => {
  try {
    await fetch("https://coordiph.herokuapp.com/tickets/enviarcorreo", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        nombre_usuario: ticket.nombre_funcionario,
        categoria_ticket: ticket.categoria,
        descripcion_problema: ticket.descripcion_problema,
        fecha_reporte: ticket.fecha_del_reporte,
        correo_solicitante: ticket.correo_solicitante,
        consecutivo_ticket: ticket.contador,
      }),
    });
  } catch (error) {
    console.warn("No se pudo enviar el correo del ticket:", error);
  }
};

export const ESTADOS = [
  "Pendiente",
  "En Proceso",
  "Requisición de compras",
  "Desarrollo de software",
  "Finalizado",
];

export const RESPONSABLES = ["COORDINADOR DE DESARROLLO"];

export const CARGOS = [
  "Ejecutivo de Cuenta",
  "Coordinador de Gestión Humana",
];

export const MAX_FOTOS = 6;
export const CAMPOS_FOTO = Array.from({ length: MAX_FOTOS }, (_, i) => `url_foto_${i + 1}`);
export const CAMPOS_SOLUCION = Array.from({ length: MAX_FOTOS }, (_, i) => `url_solucion_${i + 1}`);

const PALETA = {
  "Finalizado": { fondo: "#e6f7ed", texto: "#0d7a3d", punto: "#27ae60" },
  "En Proceso": { fondo: "#fff4e2", texto: "#a35c00", punto: "#f39c12" },
  "Requisición de compras": { fondo: "#f3ecfd", texto: "#6b34b8", punto: "#8e44ad" },
  "Desarrollo de software": { fondo: "#e8f1fd", texto: "#1a5fa8", punto: "#2980b9" },
  "Pendiente": { fondo: "#fdeceb", texto: "#b3261e", punto: "#e74c3c" },
};

export const paletaEstado = (estado) => PALETA[estado] || PALETA["Pendiente"];
export const colorEstado = (estado) => paletaEstado(estado).punto;


export const normalizarEstado = (estado) => {
  const limpio = String(estado || "").trim();
  const coincide = ESTADOS.find((e) => e.toLowerCase() === limpio.toLowerCase());
  return coincide || (limpio || "Pendiente");
};

export const normalizarNombre = (texto = "") =>
  texto
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .trim()
    .replace(/\s+/g, " ");

export const inicialesDe = (texto = "") =>
  texto.trim().split(/\s+/).slice(0, 2).map((p) => p[0]?.toUpperCase() || "").join("") || "?";

export const soloFecha = (valor = "") => String(valor || "").substring(0, 10);

export const fechaLegible = (valor) => {
  const iso = soloFecha(valor);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(iso)) return valor || "—";
  const [a, m, d] = iso.split("-");
  return `${d}/${m}/${a}`;
};

export const fotosDe = (registro, campos = CAMPOS_FOTO) =>
  campos
    .map((campo) => registro?.[campo])
    .filter((url) => typeof url === "string" && url.startsWith("http"));

export const repartirFotos = (urls, campos = CAMPOS_FOTO) =>
  campos.reduce((acc, campo, i) => ({ ...acc, [campo]: urls[i] || "" }), {});

export const cargarCategorias = async () => {
  const datos = await consultarSimple(RUTA_CATEGORIAS);
  return Object.entries(datos || {})
    .map(([id, item]) => ({ id, ...item }))
    .sort((a, b) =>
      String(a.descripcion_categoria || "").localeCompare(String(b.descripcion_categoria || ""))
    );
};

export const cargarUsuariosTickets = async () => {
  const datos = await consultarSimple(RUTA_USUARIOS);
  return Object.entries(datos || {})
    .map(([id, item]) => ({ id, ...item }))
    .sort((a, b) =>
      String(a.Nombre_Completo || "").localeCompare(String(b.Nombre_Completo || ""))
    );
};


export const Modal = ({ titulo, subtitulo, ancho = "md", pie, alCerrar, children }) => {
  useEffect(() => {
    const alPulsarTecla = (e) => e.key === "Escape" && alCerrar?.();
    document.addEventListener("keydown", alPulsarTecla);

    const overflowPrevio = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", alPulsarTecla);
      document.body.style.overflow = overflowPrevio;
    };
  }, [alCerrar]);

  return createPortal(
    <div className="tk-overlay" onMouseDown={(e) => e.target === e.currentTarget && alCerrar?.()}>
      <div className={`tk-modal tk-w-${ancho}`} role="dialog" aria-modal="true">
        <div className="tk-modal-cabeza">
          <div style={{ minWidth: 0 }}>
            <h2>{titulo}</h2>
            {subtitulo && <p>{subtitulo}</p>}
          </div>
          <button type="button" className="tk-cerrar" onClick={alCerrar} aria-label="Cerrar">
            <i className="bi bi-x-lg" />
          </button>
        </div>

        <div className="tk-modal-cuerpo">{children}</div>

        {pie && <div className="tk-modal-pie">{pie}</div>}
      </div>
    </div>,
    document.body
  );
};


export const Confirmacion = ({ titulo, mensaje, textoConfirmar = "Eliminar", peligro = true, alConfirmar, alCerrar }) => (
  <Modal
    titulo={titulo}
    ancho="sm"
    alCerrar={alCerrar}
    pie={
      <div className="tk-derecha">
        <button type="button" className="tk-btn" onClick={alCerrar}>Cancelar</button>
        <button
          type="button"
          className={`tk-btn ${peligro ? "tk-btn-peligro" : "tk-btn-primario"}`}
          onClick={alConfirmar}
        >
          {textoConfirmar}
        </button>
      </div>
    }
  >
    <div style={{ fontSize: "0.9rem", color: "var(--tk-tinta-2)", lineHeight: 1.5 }}>{mensaje}</div>
  </Modal>
);

export const useConfirmacion = () => {
  const [config, setConfig] = useState(null);

  const pedirConfirmacion = useCallback((opciones) => setConfig(opciones), []);
  const cerrar = useCallback(() => setConfig(null), []);

  const elemento = config ? (
    <Confirmacion
      {...config}
      alCerrar={cerrar}
      alConfirmar={async () => {
        cerrar();
        await config.alConfirmar?.();
      }}
    />
  ) : null;

  return { elemento, pedirConfirmacion };
};


export const Aviso = ({ tipo = "exito", texto, alCerrar }) => {
  useEffect(() => {
    const id = setTimeout(() => alCerrar?.(), 3200);
    return () => clearTimeout(id);
  }, [alCerrar]);

  const estilos = {
    exito: { icono: "bi-check-circle-fill", color: "#0d7a3d", fondo: "#e6f7ed" },
    error: { icono: "bi-exclamation-triangle-fill", color: "#b3261e", fondo: "#fdeceb" },
    info: { icono: "bi-info-circle-fill", color: "#1a5fa8", fondo: "#e8f1fd" },
  }[tipo];

  return createPortal(
    <div
      style={{
        position: "fixed", zIndex: 4000, left: "50%", bottom: 26, transform: "translateX(-50%)",
        display: "flex", alignItems: "center", gap: 10, padding: "11px 18px",
        borderRadius: 980, background: estilos.fondo, color: estilos.color,
        fontFamily: "var(--tk-fuente)", fontSize: "0.87rem", fontWeight: 600,
        boxShadow: "0 8px 30px rgba(0,0,0,.18)", maxWidth: "92vw",
      }}
      onClick={alCerrar}
    >
      <i className={`bi ${estilos.icono}`} />
      <span>{texto}</span>
    </div>,
    document.body
  );
};

export const useAviso = () => {
  const [aviso, setAviso] = useState(null);

  const avisar = useCallback((texto, tipo = "exito") => setAviso({ texto, tipo }), []);
  const cerrar = useCallback(() => setAviso(null), []);

  const elemento = aviso ? <Aviso {...aviso} alCerrar={cerrar} /> : null;

  return { elemento, avisar };
};


export const BadgeEstado = ({ estado }) => {
  const { fondo, texto, punto } = paletaEstado(normalizarEstado(estado));
  return (
    <span className="tk-badge" style={{ background: fondo, color: texto }}>
      <i className="bi bi-circle-fill" style={{ color: punto }} />
      {normalizarEstado(estado)}
    </span>
  );
};


export const Campo = ({ etiqueta, ayuda, anchoTotal, children }) => (
  <div className={`tk-campo ${anchoTotal ? "tk-ancho-total" : ""}`}>
    {etiqueta && <label>{etiqueta}</label>}
    {children}
    {ayuda && <p className="tk-ayuda">{ayuda}</p>}
  </div>
);


export const GaleriaFotos = ({
  urls = [],
  archivos = [],
  alCambiarUrls,
  alCambiarArchivos,
  soloLectura = false,
  alAmpliar,
}) => {
  const refArchivo = useRef(null);
  const total = urls.length + archivos.length;

  const agregar = (lista) => {
    const espacio = MAX_FOTOS - total;
    if (espacio <= 0) return;
    alCambiarArchivos?.([...archivos, ...Array.from(lista).slice(0, espacio)]);
  };

  if (soloLectura && total === 0) {
    return <p className="tk-vacio" style={{ padding: "14px 0" }}>Sin fotos adjuntas.</p>;
  }

  return (
    <>
      <div className="tk-fotos">
        {urls.map((url, i) => (
          <div className="tk-foto" key={url}>
            <img src={url} alt={`Foto ${i + 1}`} onClick={() => alAmpliar?.(url)} loading="lazy" />
            {!soloLectura && (
              <button
                type="button"
                className="tk-foto-quitar"
                title="Quitar foto"
                onClick={() => alCambiarUrls?.(urls.filter((u) => u !== url))}
              >
                <i className="bi bi-x-lg" />
              </button>
            )}
          </div>
        ))}

        {archivos.map((archivo, i) => (
          <div className="tk-foto" key={`nuevo-${i}-${archivo.name}`}>
            <img src={URL.createObjectURL(archivo)} alt={archivo.name} />
            <button
              type="button"
              className="tk-foto-quitar"
              title="Quitar foto"
              onClick={() => alCambiarArchivos?.(archivos.filter((_, j) => j !== i))}
            >
              <i className="bi bi-x-lg" />
            </button>
          </div>
        ))}

        {!soloLectura && total < MAX_FOTOS && (
          <button type="button" className="tk-soltar" onClick={() => refArchivo.current?.click()}>
            <i className="bi bi-camera" />
            Agregar
          </button>
        )}
      </div>

      {!soloLectura && (
        <>
          <input
            ref={refArchivo}
            type="file"
            accept="image/*"
            multiple
            style={{ display: "none" }}
            onChange={(e) => {
              agregar(e.target.files);
              e.target.value = "";
            }}
          />
          <p className="tk-ayuda" style={{ marginTop: 8 }}>
            {total} de {MAX_FOTOS} fotos.
          </p>
        </>
      )}
    </>
  );
};


export const VisorFoto = ({ url, alCerrar }) =>
  createPortal(
    <div
      className="tk-overlay"
      style={{ zIndex: 3500, cursor: "zoom-out" }}
      onClick={alCerrar}
    >
      <img
        src={url}
        alt="Foto ampliada"
        style={{ maxWidth: "92vw", maxHeight: "88vh", borderRadius: 14, boxShadow: "0 20px 60px rgba(0,0,0,.4)" }}
      />
    </div>,
    document.body
  );


export const PanelFirma = ({ titulo, alGuardar, alCerrar }) => {
  const refLienzo = useRef(null);
  const [vacio, setVacio] = useState(true);

  useEffect(() => {
    const lienzo = refLienzo.current;
    if (!lienzo) return;

    const proporcion = window.devicePixelRatio || 1;
    const caja = lienzo.getBoundingClientRect();
    lienzo.width = caja.width * proporcion;
    lienzo.height = caja.height * proporcion;

    const ctx = lienzo.getContext("2d");
    ctx.scale(proporcion, proporcion);
    ctx.strokeStyle = "#1d1d1f";
    ctx.lineWidth = 2.2;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";

    let dibujando = false;

    const posicion = (e) => {
      const rect = lienzo.getBoundingClientRect();
      const punto = e.touches?.[0] || e;
      return { x: punto.clientX - rect.left, y: punto.clientY - rect.top };
    };

    const iniciar = (e) => {
      e.preventDefault();
      dibujando = true;
      setVacio(false);
      const { x, y } = posicion(e);
      ctx.beginPath();
      ctx.moveTo(x, y);
    };

    const mover = (e) => {
      if (!dibujando) return;
      e.preventDefault();
      const { x, y } = posicion(e);
      ctx.lineTo(x, y);
      ctx.stroke();
    };

    const terminar = () => {
      if (!dibujando) return;
      dibujando = false;
      ctx.closePath();
    };

    lienzo.addEventListener("mousedown", iniciar);
    lienzo.addEventListener("mousemove", mover);
    window.addEventListener("mouseup", terminar);
    lienzo.addEventListener("touchstart", iniciar, { passive: false });
    lienzo.addEventListener("touchmove", mover, { passive: false });
    lienzo.addEventListener("touchend", terminar);

    return () => {
      lienzo.removeEventListener("mousedown", iniciar);
      lienzo.removeEventListener("mousemove", mover);
      window.removeEventListener("mouseup", terminar);
      lienzo.removeEventListener("touchstart", iniciar);
      lienzo.removeEventListener("touchmove", mover);
      lienzo.removeEventListener("touchend", terminar);
    };
  }, []);

  const limpiar = () => {
    const lienzo = refLienzo.current;
    const ctx = lienzo.getContext("2d");
    ctx.clearRect(0, 0, lienzo.width, lienzo.height);
    setVacio(true);
  };

  return (
    <Modal
      titulo={titulo}
      subtitulo="Dibuja la firma con el dedo o el mouse"
      ancho="md"
      alCerrar={alCerrar}
      pie={
        <>
          <button type="button" className="tk-btn" onClick={limpiar}>
            <i className="bi bi-eraser" /> Limpiar
          </button>
          <div className="tk-derecha">
            <button type="button" className="tk-btn" onClick={alCerrar}>Cancelar</button>
            <button
              type="button"
              className="tk-btn tk-btn-primario"
              disabled={vacio}
              onClick={() => alGuardar(refLienzo.current.toDataURL("image/png"))}
            >
              Guardar firma
            </button>
          </div>
        </>
      }
    >
      <canvas ref={refLienzo} className="tk-lienzo" />
    </Modal>
  );
};
